<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>

<div>
	<div>
		<app-clipboard></app-clipboard>
	</div>

	<div class="list-wrapper">
		@if ((adminService.selectedClient$ | async) === undefined) {
			<app-client-list></app-client-list>
		}

		@if (
			(adminService.selectedClient$ | async) !== undefined && (adminService.selectedCourse$ | async) === undefined
		) {
			<!-- Make user create a location first under this client -->
			@if (!hasLocations()) {
				<nz-tabs>
					<nz-tab nzTitle="Locations">
						<app-location-list></app-location-list>
					</nz-tab>
				</nz-tabs>
			}

			<!-- Once at least one location exists default to the course's tab -->
			@if (hasLocations()) {
				<nz-tabs>
					<nz-tab nzTitle="Courses">
						<app-course-list></app-course-list>
					</nz-tab>
					<nz-tab nzTitle="Locations">
						<app-location-list></app-location-list>
					</nz-tab>
					@if (isAdmin()) {
						<nz-tab nzTitle="Exports">
							<app-client-user-export></app-client-user-export>
						</nz-tab>
					}
					@if (isAdmin()) {
						<nz-tab nzTitle="Logins">
							<app-login-tracking-list
								[logins]="logins()"
								[showUsername]="true"
							></app-login-tracking-list>
						</nz-tab>
					}
				</nz-tabs>
			}
		}

		@if (
			(adminService.selectedClient$ | async) !== undefined &&
			(adminService.selectedCourse$ | async) !== undefined &&
			(adminService.selectedUnit$ | async) === undefined
		) {
			<app-unit-list></app-unit-list>
		}

		@if (
			(adminService.selectedClient$ | async) !== undefined &&
			(adminService.selectedCourse$ | async) !== undefined &&
			(adminService.selectedUnit$ | async) !== undefined &&
			(adminService.selectedLesson$ | async) === undefined
		) {
			<app-lesson-list></app-lesson-list>
		}

		@if (
			(adminService.selectedClient$ | async) !== undefined &&
			(adminService.selectedCourse$ | async) !== undefined &&
			(adminService.selectedUnit$ | async) !== undefined &&
			(adminService.selectedLesson$ | async) !== undefined &&
			(adminService.selectedActivity$ | async) === undefined
		) {
			<app-activity-list></app-activity-list>
		}

		@if (
			(adminService.selectedClient$ | async) !== undefined &&
			(adminService.selectedCourse$ | async) !== undefined &&
			(adminService.selectedUnit$ | async) !== undefined &&
			(adminService.selectedLesson$ | async) !== undefined &&
			(adminService.selectedActivity$ | async) !== undefined &&
			(adminService.selectedContent$ | async) === undefined
		) {
			<app-content-list></app-content-list>
		}
	</div>
</div>
